import { SxProps, Theme } from '@mui/material/styles';

/**
 * Full-width shell: gray canvas, at least one viewport tall, horizontal padding.
 * No fixed `height`, no inner `overflow` — content defines height and the browser
 * scrolls the document normally so padding matches real scroll height.
 */
/** Fills the withdrawal layout main area (below fixed nav) without forcing another viewport height. */
export const publicRequestContentSx: SxProps<Theme> = {
    flex: 1,
    minHeight: 0,
    width: '100%',
    backgroundColor: '#F2F2F2',
    boxSizing: 'border-box',
    paddingX: 2,
    paddingY: '80px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
};

export const magicLinkPageOuterSx: SxProps<Theme> = {
    minHeight: '100dvh',
    width: '100%',
    // Solid screen background — same gray (#F2F2F2 / theme grey[50]) used by the
    // in-app RequestForm shell so white Section cards pop on top of it.
    backgroundColor: '#F2F2F2',
    boxSizing: 'border-box',
    paddingX: 2,
    paddingY: { xs: 2, md: 3 },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
};

/**
 * Centered content column (max-width on desktop). Stack sections, logo, and actions
 * here with `gap`; no `minHeight: 100%` or nested scroll regions.
 */
export const magicLinkPageColumnSx: SxProps<Theme> = {
    width: '100%',
    maxWidth: { xs: '100%', md: '620px' },
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
};

/**
 * Optional vertical rhythm for compact “hero” status blocks (intro, errors, etc.).
 * Avoids `flex: 1` / percentage height chains that fight window scrolling.
 */
export const magicLinkCenteredHeroInnerSx: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    gap: 2,
    paddingY: { xs: 2, md: 4 },
};
